import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, ValidatorFn} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {SchemaService} from '../../services/schema.service';
import {ValidationService} from '../../services/validation.service';
import {RestService} from '../../services/rest.service';
import {AlertController} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import {LoadingService} from '../../services/loading.service';
import {MatomoTracker} from 'ngx-matomo-client';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.page.html',
  styleUrls: ['./reset-password.page.scss']
})
export class ResetPasswordPage implements OnInit {
  email = new FormControl('', this.validatorFnForProperty('email'));

  resetPasswordFormGroup: FormGroup;

  constructor(
    private matomoTracker: MatomoTracker,
    private loadingService: LoadingService,
    private router: Router,
    private schemaService: SchemaService,
    private validationService: ValidationService,
    private activatedRoute: ActivatedRoute,
    private restService: RestService,
    private alertCtrl: AlertController,
    private translate: TranslateService
  ) {
    this.resetPasswordFormGroup = new FormGroup({
      email: this.email
    });
  }

  private listenToRouteParams() {
    this.activatedRoute.params.subscribe(async params => {
      if (params['email']) {
        this.email.setValue(params['email']);
      }
    });
  }

  ngOnInit() {
    this.listenToRouteParams();
  }

  isValid(): boolean {
    return this.resetPasswordFormGroup.valid;
  }

  async onResetPassword() {
    const loader = await this.loadingService.createAndShowDefaultLoadingMessage();
    try {
      await this.restService.resetPassword({email: this.email.value});
      await this.successAlert();
      await this.router.navigateByUrl('/login');
      this.matomoTracker.trackEvent('auth', 'reset-password');
    } finally {
      loader.dismiss();
    }
  }

  async successAlert() {
    const alert = await this.alertCtrl.create({
      message: this.translate.instant('reset-password-page.please-check-inbox', {email: this.email.value})
    });
    alert.present();
  }

  async onBack() {
    await this.router.navigateByUrl('/login');
  }

  private validatorFnForProperty(property: string): ValidatorFn[] {
    // todo: maybe it would be nicer to not have to get the schema from schemaservice ourselves,
    return this.validationService.getFormValidator(
      this.schemaService.resetPasswordEmailSchema,
      property
    );
  }

}
